import compose from 'ramda/src/compose';
import { normalizePhone } from '@s7/ui-kit/utils/phone';
import replacePhoneCode from './replacePhoneCode';
var CARD_PATTERN = /^\d{9}$/;
var PHONE_PATTERN = /^\d{10,}$/; // since a card or phone can only contain numbers and mask symbols "+", "-", "()"
// any other value is treated as email

var EMAIL_PATTERN = /[^0-9()+-]/; // const EMAIL_PATTERN = /.+@.+\..+/i

var clearMask = function clearMask(value) {
  return value.replace(/[-+()\s]/g, '');
};

var shouldShowPhoneMask = function shouldShowPhoneMask(value) {
  return value[0] === '0' ? value : normalizePhone(value);
};

export default function formatLogin(value) {
  var formattedLogin = value;
  var type = '';
  var loginWithoutMask = value;
  var valueWithoutMask = clearMask(value);

  if (CARD_PATTERN.test(valueWithoutMask)) {
    type = 'card';
    loginWithoutMask = clearMask(value);
  } else if (PHONE_PATTERN.test(valueWithoutMask)) {
    formattedLogin = compose(shouldShowPhoneMask, replacePhoneCode)(value);
    type = 'phone';
    loginWithoutMask = clearMask(formattedLogin);
  } else if (EMAIL_PATTERN.test(value)) {
    type = 'email';
    formattedLogin = value;
  }

  return {
    formattedLogin: formattedLogin,
    nonFormattedLogin: type === 'email' || type === 'card' ? value : replacePhoneCode(value),
    loginWithoutMask: loginWithoutMask,
    type: type
  };
}